import React from "react";
import { APIURL } from "../../config";
import { useParams } from "react-router-dom";
import { Icon, AnchorButton } from "@blueprintjs/core";

export function BackButton() {
    const { createID, updateID } = useParams();
    const backURL = `${APIURL}/template/${createID || updateID}/edit`;
    return (
      <div className="bp4-navbar-group bp4-align-left margin-left-10">
        <AnchorButton
          href={backURL}
          icon={<Icon icon="arrow-left" />}
          text="Back To Admin"
        />
      </div>
    );
}